/**
 * The account's own CMMD organization, read from its already-provisioned
 * Environments, a fact, not a guess, the same standard
 * `useFirstRunEnvironment`'s `catalogOrganizationId` holds itself to
 * (CMMD-Center/forge#3572 section 3). Two callers share this: the
 * project-placement bootstrap fallback (`cloudCmmdProjectPlacement.ts`) and
 * the workspace store's startup seed (`authenticatedAppSurface.workspaceSideEffects.ts`).
 *
 * Filtered to Environments this user owns (`cmmdUserId`), not every row the
 * account's memberships can see: the cloud-project catalog CMMD-Center/forge#3576
 * left cross-workspace by design (every project the account's memberships can
 * reach, never scoped down), so an unfiltered read would call a teammate's
 * Environment "the user's own runtime."
 *
 * Returns null when the account owns no Environment yet, or when its owned
 * Environments span more than one organization: an ambiguous fact must
 * refuse, not pick one side of it.
 */
export function resolveOwnRuntimeOrganizationId(input: {
  readonly userId: number;
  readonly environments: ReadonlyArray<{
    readonly cmmdOrganizationId: number;
    readonly cmmdUserId: number;
  }>;
}): number | null {
  const organizationIds = new Set<number>();
  for (const environment of input.environments) {
    if (environment.cmmdUserId === input.userId) {
      organizationIds.add(environment.cmmdOrganizationId);
    }
  }
  if (organizationIds.size !== 1) return null;
  const [soleOrganizationId] = organizationIds;
  return soleOrganizationId ?? null;
}
